// Mock data for S S Diagnostic Centre

export const services = [
  {
    id: 1,
    name: 'Pathology Lab',
    description: 'Complete blood tests, urine analysis, and comprehensive health checkups with accurate results.',
    icon: 'microscope'
  },
  {
    id: 2,
    name: '3D / 4D Sonography',
    description: 'Advanced 3D and 4D ultrasound imaging for detailed fetal visualization and bonding.',
    icon: 'scan'
  },
  {
    id: 3,
    name: 'Anomaly Scan',
    description: 'Detailed fetal anatomy scan to detect any structural abnormalities during pregnancy.',
    icon: 'activity'
  },
  {
    id: 4,
    name: 'NT Scan',
    description: 'Nuchal Translucency scan for early detection of chromosomal abnormalities.',
    icon: 'heart-pulse'
  },
  {
    id: 5,
    name: 'Growth Scan',
    description: 'Monitor fetal growth and development throughout pregnancy stages.',
    icon: 'trending-up'
  },
  {
    id: 6,
    name: 'Obstetric Doppler',
    description: 'Blood flow assessment in umbilical cord and placenta during pregnancy.',
    icon: 'waves'
  },
  {
    id: 7,
    name: 'Fetal 2D Echo',
    description: 'Detailed examination of fetal heart structure and function.',
    icon: 'heart'
  },
  {
    id: 8,
    name: 'USG Abdomen & Pelvis',
    description: 'Comprehensive ultrasound imaging of abdominal and pelvic organs.',
    icon: 'scan-line'
  },
  {
    id: 9,
    name: 'Breast Sonography',
    description: 'Non-invasive breast imaging for early detection and screening.',
    icon: 'stethoscope'
  },
  {
    id: 10,
    name: 'Thyroid / Neck Sonography',
    description: 'Detailed thyroid gland and neck structure examination.',
    icon: 'radio'
  },
  {
    id: 11,
    name: 'Renal Doppler',
    description: 'Blood flow assessment in kidney vessels for renal function evaluation.',
    icon: 'droplet'
  },
  {
    id: 12,
    name: 'Venous Doppler',
    description: 'Evaluate blood flow in veins to detect blockages or clots.',
    icon: 'git-branch'
  },
  {
    id: 13,
    name: 'Arterial Doppler',
    description: 'Assess blood flow in arteries to detect circulation problems.',
    icon: 'git-merge'
  },
  {
    id: 14,
    name: 'Digital X-Ray',
    description: 'High-quality digital radiography with minimal radiation exposure.',
    icon: 'scan-search'
  },
  {
    id: 15,
    name: 'Portable X-Ray',
    description: 'Mobile X-ray services for home visits and bedridden patients.',
    icon: 'move'
  },
  {
    id: 16,
    name: 'HSG',
    description: 'Hysterosalpingography for uterus and fallopian tube evaluation.',
    icon: 'circle-dot'
  },
  {
    id: 17,
    name: '2D Echo',
    description: 'Echocardiography for comprehensive heart function assessment.',
    icon: 'heart-pulse'
  },
  {
    id: 18,
    name: 'Stress Test (TMT)',
    description: 'Treadmill test to evaluate heart performance during physical activity.',
    icon: 'activity'
  }
];

export const branches = [
  {
    id: 1,
    name: 'Hadapsar Branch',
    phones: ['8087352172', '8087362172'],
    address: '1st Floor, Flat No.4, Aru Palace, Malwadi Rd, near Mahalaxmi Temple, Bhosale Nagar, Hadapsar, Pune, Maharashtra 411028',
    mapUrl: 'https://maps.google.com/?q=18.5089,73.9260',
    embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.3!2d73.9260!3d18.5089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDMwJzMyLjAiTiA3M8KwNTUnMzMuNiJF!5e0!3m2!1sen!2sin!4v1234567890'
  },
  {
    id: 2,
    name: 'Kondhwa Branch',
    phones: ['7385102172', '7385602172'],
    address: 'Shop No. 10, Sheetal Square, near Sheetal Petrol Pump, Meeta Nagar, Kondhwa, Pune, Maharashtra 411048',
    mapUrl: 'https://maps.google.com/?q=18.4620,73.8900',
    embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3785.1!2d73.8900!3d18.4620!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDI3JzQzLjIiTiA3M8KwNTMnMjQuMCJF!5e0!3m2!1sen!2sin!4v1234567891'
  },
  {
    id: 3,
    name: 'Bhekrai Nagar Branch',
    phones: ['8180082172', '8180872172'],
    address: 'Flat No. A102, Trimurti Apartment, opp. BP Deshmukh Petrol Pump, Bhekrai Nagar, Tukai Darshan, Phursungi, Pune, Maharashtra 412308',
    mapUrl: 'https://maps.google.com/?q=18.5180,73.9850',
    embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.0!2d73.9850!3d18.5180!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDMxJzA0LjgiTiA3M8KwNTknMDYuMCJF!5e0!3m2!1sen!2sin!4v1234567892'
  }
];
